import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
  faCheckCircle,
  faPhone,
  faEnvelope,
  faCheck,
  faUserDoctor,
  faUserGroup,
  faHospital,
  faBedPulse,
  faHandHoldingDollar,
  faChartPie,
  faMapLocationDot,
  faChevronRight,
  faArrowLeft,
  faDesktop,
  faChevronLeft,
  faUser,
  faChartLine,
  faMoneyBillTransfer,
  faFileLines,
  faHeadset,
  faTooth,
  faTeeth,
  faSyringe,
  faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

function initHeroIcons() {
  library.add(faCheckCircle);

  dom.watch();
}

function initProsIcons() {
  library.add(
    faHospital,
    faHandHoldingDollar,
    faChartPie,
    faUserGroup,
    faDesktop
  );

  dom.watch();
}

function initBenefitsIcon() {
  library.add(faMapLocationDot, faUserDoctor, faBedPulse);

  dom.watch();
}

function initCommonIcons() {
  library.add(faCheck, faArrowLeft, faChevronRight, faChevronLeft);

  dom.watch();
}

function initHumanResourcesIcons() {
  library.add(faUser, faChartLine, faMoneyBillTransfer, faFileLines, faHeadset);

  dom.watch();
}

function initMediaIcons() {
  library.add(faWhatsapp, faEnvelope, faPhone);

  dom.watch();
}

function initDentistIcons() {
  library.add(faTooth, faTeeth, faSyringe, faClipboardCheck);

  dom.watch();
}

export {
  initCommonIcons,
  initMediaIcons,
  initProsIcons,
  initBenefitsIcon,
  initHeroIcons,
  initHumanResourcesIcons,
  initDentistIcons,
};
